
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import BrandStoryPage from '../pages/brand-story/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/brand-story',
    element: <BrandStoryPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
